"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ModalBody;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

/* eslint react/prop-types: 0 */

/**
 * Representation of a body in the Dialog.
 * @returns {React.ReactElement} ModalBody
 */
function ModalBody({
  children,
  id
}) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'modal-body',
    id: id
  }, children);
}

ModalBody.propTypes = {
  /** Child elements */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),

  /** Required ID for a11y */
  id: _propTypes.default.string.isRequired
};